module.exports = __webpack_public_path__ + "media/images/balance-product-arrowdown1-3f1f36d00f9efc030def382c0b5a91aa.png";